function checkWindowSize() {
  var collapsibleGroups = document.querySelectorAll('.footer-block--menu [data-collapsible-group]');
  if (window.innerWidth <= 768) {
    if (collapsibleGroups.length > 0) {
      collapsibleGroups[0].classList.add('collapsible-is-open');
    }
  } else {
    if (collapsibleGroups.length > 0) {
      collapsibleGroups[0].classList.remove('collapsible-is-open');
    }
  }
}

document.addEventListener('DOMContentLoaded', checkWindowSize);
window.addEventListener('resize', checkWindowSize);
